<div
  *ngIf="!loading"
  class="flex flex-row-reverse justify-end text-yellow-three"
  [class.score-container--rating]="canRate"
>
  <ng-container *ngFor="let star of [5, 4, 3, 2, 1]">
    <div class="score-star mr-2" (click)="onRate(star)" [class.cursor-pointer]="canRate">
      <svg-icon
        src="assets/images/svg-icons/{{
          rate >= star - 0.5 || rate <= star - 1 ? 'icon-star-fill' : 'icon-star-half'
        }}.svg"
        [class.text-theme-gray-sixteen]="rate <= star - 1"
        [svgStyle]="{ 'width.px': '18' }"
      ></svg-icon>
    </div>
  </ng-container>
</div>

<app-loader-dots *ngIf="loading"></app-loader-dots>
